import { useEffect } from "react";
import mixpanel, { Dict } from "mixpanel-browser";

const useMixpanel = () => {
  useEffect(() => {
    mixpanel.init(process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN as string, {
      debug: true,
      track_pageview: true,
      persistence: "localStorage",
    });
  }, []);

  const identifyUser = (userId: string) => {
    mixpanel.identify(userId);
  };

  const trackEvent = (eventName: string, properties?: Dict) => {
    mixpanel.track(eventName, properties);
  };

  const setMixpanelUser = (email?: string, username?: string) => {
    mixpanel.people.set({
      $email: email ?? "",
      $name: username ?? "",
    });
  };

  return {
    identifyUser,
    trackEvent,
    setMixpanelUser,
  };
};

export default useMixpanel;
